import React from 'react'
import { connect } from 'react-redux'
import { withNamespaces } from 'react-i18next'
import { MapPin, CalendarDays, User, CreditCard, Check } from 'lucide-react'

class NmStepBarRental extends React.Component {

  getBarGradient() {
    const { qrData } = this.props
    const { primaryColor, secondaryColor } = qrData?.headerConfig || {}
    if (primaryColor && secondaryColor) {
      return `linear-gradient(90deg, ${primaryColor} 0%, ${secondaryColor} 100%)`
    }
    return 'linear-gradient(90deg, #01315f, #067ddb)'
  }

  getButtonGradient() {
    const { qrData } = this.props
    const { buttonColor1, buttonColor2 } = qrData?.headerConfig || {}
    if (buttonColor1 && buttonColor2) {
      return `linear-gradient(135deg, ${buttonColor1}, ${buttonColor2})`
    }
    return 'linear-gradient(135deg, #01315f, #067ddb)'
  }

  getButtonColor1() {
    const { qrData } = this.props
    return qrData?.headerConfig?.buttonColor1 || '#067ddb'
  }

  hexToRgba(hex, alpha) {
    const h = hex.replace('#', '')
    const r = parseInt(h.substring(0, 2), 16)
    const g = parseInt(h.substring(2, 4), 16)
    const b = parseInt(h.substring(4, 6), 16)
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
  }

  renderStep(stepNumber, currentStep, label, Icon) {
    const isActive = currentStep === stepNumber
    const isOld    = currentStep > stepNumber
    const buttonGradient = this.getButtonGradient()

    const iconStyle = isActive
      ? { animation: 'nmSbRentalPulse 1s ease-in-out infinite alternate' }
      : isOld
        ? { background: buttonGradient }
        : {}

    const iconCls  = `nm-sb-icon${isActive ? ' nm-sb-icon--active' : ''}${isOld ? ' nm-sb-icon--done' : ''}`
    const labelCls = `nm-sb-label${isActive ? ' nm-sb-label--active' : ''}${isOld ? ' nm-sb-label--done' : ''}`

    return (
      <div className="nm-sb-step">
        <div className={iconCls} style={iconStyle}>
          {isOld ? <Check size={15} /> : <Icon size={15} />}
        </div>
        <span className={labelCls}>{label}</span>
      </div>
    )
  }

  render() {
    const { step, t }    = this.props
    const barGradient    = this.getBarGradient()
    const buttonGradient = this.getButtonGradient()
    const btnColor1      = this.getButtonColor1()
    const inactiveBg     = this.hexToRgba(btnColor1, 0.20)
    const inactiveColor  = this.hexToRgba(btnColor1, 0.60)

    return (
      <>
        <style>{`
          @keyframes nmSbRentalPulse {
            from { background: ${buttonGradient}; color: var(--customer-button-text, #ffffff); }
            to   { background: ${inactiveBg};     color: ${inactiveColor}; }
          }
        `}</style>

        <div className="nm-sb" style={{ background: barGradient }}>
          <div className="nm-sb-inner">

            {this.renderStep(1, step, t('Zona'), MapPin)}

            <div
              className={`nm-sb-line${step > 1 ? ' nm-sb-line--done' : ''}`}
              style={step > 1 ? { background: buttonGradient } : {}}
            />

            {this.renderStep(2, step, t('Fechas'), CalendarDays)}

            <div
              className={`nm-sb-line${step > 2 ? ' nm-sb-line--done' : ''}`}
              style={step > 2 ? { background: buttonGradient } : {}}
            />

            {this.renderStep(3, step, t('Datos'), User)}

            <div
              className={`nm-sb-line${step > 3 ? ' nm-sb-line--done' : ''}`}
              style={step > 3 ? { background: buttonGradient } : {}}
            />

            {this.renderStep(4, step, t('Pago'), CreditCard)}

          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  qrData: state.qrs.qr
})

export default connect(mapStateToProps)(withNamespaces()(NmStepBarRental))
